import React from "react";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import ReactTable from "react-table";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker, faTimes } from "@fortawesome/free-solid-svg-icons";
import useSearchHook from "hooks/useSearch.hook";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import ModalBikeLastPosition from "views/pages/bikes-history/modal-bike-last-position";
import { triggerSearch, triggerDelete } from "actions/bike-trigger-history/actions";
import Filters from "./filters";

const BikesTriggerHistory = (props) => {
  const { loading, list, bikeLoading, pages, triggerDelete } = props;
  const {
    page,
    size,
    filters,
    handleSearch,
    handleReset,
    handlePageChange,
    handleSortedChange,
    handlePageSizeChange
  } = useSearchHook(props.triggerSearch, {
    size: 30,
    sort: "date,desc"
  });

  const handleDelete = (id) => {
    triggerDelete(id);
  };

  const handleOpenCoordinates = (original) => {
    const { closeCustomModal, openCustomModal } = props;
    const modalObj = {
      id: "bike-history-position",
      modalSettings: {
        size: "sm"
      },
      header: "Bike Position",
      children: (
        <ModalBikeLastPosition
          coordinates={[original.longitude, original.latitude]}
          onCancel={() => closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  };

  const getColumns = () => [
    {
      Header: "#",
      accessor: "id",
    },
    {
      id: "date",
      Header: "Date",
      accessor: original => moment(original.date)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => moment(original.date)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      Header: "Bike",
      accessor: "bike",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.bike) {
          return (
            <Link to={`/bikes/${original.bike}`}>
              {original.bike}
            </Link>
          );
        }
        return null;
      }
    },
    {
      Header: "Bike Status",
      accessor: "bikeStatus",
    },
    {
      Header: "User",
      accessor: "user",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.user) {
          return (
            <Link to={`/users/${original.user}`}>
              {original.user}
            </Link>
          );
        }
        return null;
      }
    },
    {
      Header: "Device",
      accessor: "device",
    },
    {
      id: "on-map",
      Header: "Map",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => original.position,
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleOpenCoordinates(original)}
          title="Bike last position"
        >
          <FontAwesomeIcon icon={faMapMarker}/>
        </button>
      )
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <React.Fragment>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleDelete(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger">
              <FontAwesomeIcon icon={faTimes}/>
            </button>
          </Popconfirm>
        </React.Fragment>
      )
    },
  ];

  return (
    <div className="w-100 p-2">
      <div className="filters">
        <Filters
          activeFilters={filters}
          totalCount={list.total_count || 0}
          handleSearch={handleSearch}
          handleReset={handleReset}
        />
      </div>

      <ReactTable
        data={list.content || []}
        headerClassName="table-header"
        columns={getColumns()}
        pageSizeOptions={[10, 20, 50, 100]}
        resizable
        className="-striped -highlight table-header-padding"
        loading={loading || bikeLoading}
        filterable={false}
        defaultFilterMethod={filterCaseInsensitive}
        style={{
          height: "calc(100vh - 140px)"
        }}
        manual={true}
        pages={pages}
        page={page}
        pageSize={size}
        onSortedChange={handleSortedChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.bikeTriggerHistory.loading,
  list: state.bikeTriggerHistory.list,
  bike: state.bike.single,
  bikeLoading: state.bike.loading,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  triggerSearch: bindActionCreators(triggerSearch, dispatch),
  triggerDelete: bindActionCreators(triggerDelete, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(BikesTriggerHistory);



// WEBPACK FOOTER //
// ./src/views/pages/bikes-trigger-history/index.js